
export const getMerchantRevenue = "/core/wallet/merchant-activity/partner";
export const getInsight = "/reports/transactions/partner/dashboard-insight";
export const getMerchantSales = "/core/wallet/sales/partner";
export const getTotalMerchants = "/auth/company/total-merchants";
export const getTotalCommission = "/core/commission/company/total-commission";
export const getTransactionHistory = `/reports/partner/transaction-history`;
export const getActiveMerchants = `/reports/transactions/partner/active-merchants`;
